import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewDomainDialogComponent } from './new-domain-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { EmailUII18nModule } from '../../../src/lib/i18n/email-ui-i18n.module';
import { MatDialogModule } from '@angular/material/dialog';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

@NgModule({
  declarations: [NewDomainDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    TranslateModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    GalaxyButtonLoadingIndicatorModule,
    GalaxyPipesModule,
    EmailUII18nModule,
    TranslateModule,
    MatDialogModule,
    GalaxyFormFieldModule,
  ],
  exports: [NewDomainDialogComponent],
})
export class NewDomainDialogModule {}
